// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f15185a9","455":"53e48e57","977":"2fea4488"}[chunkId] + ".chunk.js";
};